import React from 'react';
import YouTube from 'react-youtube';
import styled from 'styled-components';
import theme from '../../../../theme';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background: ${theme.colors.medium};
  div {
    width: 100%;
    height: 100%;
  }
`;

const TutorialVideo = () => (
  <Wrapper>
    <YouTube
      videoId="bF_ejGYYNjI"
      opts={{
        height: '100%',
        width: '100%',
        // https://developers.google.com/youtube/player_parameters
        playerVars: {
          autoplay: 0,
        },
      }}
      style={{ height: '100%', width: '100%' }}
    />
  </Wrapper>
);

export default TutorialVideo;
